import { render, staticRenderFns } from "./PagesettingComponent.vue?vue&type=template&id=3266cc52&"
import script from "./PagesettingComponent.vue?vue&type=script&lang=js&"
export * from "./PagesettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./PagesettingComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports